import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f21f9e3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "Nav"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-divide"
}, null, -1));
export default {
  __name: 'App',
  setup(__props) {
    document.documentElement.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, false);
    var lastTouchEnd = 0;
    document.documentElement.addEventListener('touchend', function (event) {
      var now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);
    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_tabbar, {
        route: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          icon: "cross",
          to: "/mul"
        }, {
          default: _withCtx(() => [_createTextVNode("乘法口诀")]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          to: "/div"
        }, {
          icon: _withCtx(() => [_hoisted_2]),
          default: _withCtx(() => [_createTextVNode("除法练习")]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          icon: "plus",
          to: "/add"
        }, {
          default: _withCtx(() => [_createTextVNode("加法练习")]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          icon: "minus",
          to: "/sub"
        }, {
          default: _withCtx(() => [_createTextVNode("减法练习")]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_router_view, {
        class: "rv"
      })]);
    };
  }
};